import clsx from 'clsx';
// Hooks
import { useAtomValue } from 'jotai';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Types
import type { StepType } from '@/lib/giveawayPicker/steps';

// Components
import Icon from '@/components/base/Icon';
// Atoms
import { currentStepAtom } from '@/components/pages/giveaway-picker/Atoms/stepsAtoms';

type StepProps = {
    step: StepType;
};

export function Step({ step }: StepProps) {
    const { t } = useTranslation('giveaway_picker');
    const currentStep = useAtomValue(currentStepAtom);
    const isCompleted = step.id < currentStep;
    const isActive = step.id === currentStep;
    const isLastStep = step.id === 4;

    return (
        <div className="flex flex-row items-center gap-2.5">
            <div
                className={clsx(
                    'flex h-8 w-8 shrink-0 items-center justify-center rounded-full border text-xs',
                    {
                        'border-icoGray-300 text-icoGray-400':
                            isCompleted || !isActive || isLastStep,
                        'border-icoBlue-200 text-icoBlue': isActive
                    }
                )}>
                {isCompleted || currentStep === 4 ? (
                    <Icon icon="check" data-testid={`icon-check-${step.id}`} />
                ) : (
                    step.id
                )}
            </div>
            <div>
                <div
                    className={clsx('mb-1 font-GMedium text-xs', {
                        'hidden text-icoGray-400 lg:block': isCompleted || !isActive || isLastStep,
                        'text-icoBlue': isActive && !isCompleted
                    })}>
                    {t('step')} {step.id}
                </div>
                <div
                    className={clsx('font-GMedium text-sm', {
                        'text-icoGray-400': isCompleted || !isActive || isLastStep,
                        'hidden lg:block': !isActive
                    })}>
                    {t(step.name)}
                </div>
            </div>
        </div>
    );
}
